<script>
    import { navigate } from 'svelte-routing';
    import { servicePaymentPeriodMessages } from '../../data/extMessages';
    import { lineProps } from '../../data/lineProps';
    import { principalStreamersNames } from '../../Environment.svelte';
    import {
        shouldVerifyPromotions,
        isVerifyingPromotions,
        store,
        store_offer,
        totalPayment,
        isDisabled,
    } from '../../Store.svelte';
    import {
        getExtMessage,
        getExtras,
        getPromos,
        isCombo,
    } from '../../Util.svelte';
    import {
        MULTI_CATEGORIES,
        LALIGA_CATEGORIES,
        APPLE_TV_INCLUDED,
        CONSTANTS,
    } from '../comparator/utils/constant';

    const {
        CATEGORY_RESIDENCIAL,
        CATEGORY_TRIPLEPLAY_MOVIL,
        CATEGORY_TRIPLEPLAY,
        CATEGORY_4PLAY,
    } = CONSTANTS;

    export let isMobile = false;

    let step;
    let showDetails;
    let total = 0;
    let totalExtrasTV = 0;
    let totalMovil = 0;
    let totalConStreaming = 0;
    let izziAhorro = 0;
    let omitir =
        $store.requestedServices.product.productFamily === 'residencial' &&
        $store.requestedServices.product.vel < 40;
    let hasStreaming = false;
    let hdItem;
    let isComplete = true;
    let category = $store.requestedServices.product.productFamily;

    $: secondaryStreamers = [];
    $: promotions = $store.requestedServices.promotions;

    const isSky = $store.requestedServices.isSky;
    const isVixIncluded = [
        'skyprepagovix',
        'skyprepago',
        // 'izzitv_ottm',
        // 'izzitv_basico',
        'izzitv_light',
        'izzitv_lightm',
    ].includes($store.requestedServices.product.nombreCode);

    const isAppleTvIncluded =
        APPLE_TV_INCLUDED.has($store.requestedServices.product.productFamily) &&
        $store.requestedServices.product.vel >= 200;

    const isSkeeloIncluded = MULTI_CATEGORIES.has(
        $store.requestedServices.product.productFamily
    );

    const isLaLigaIncluded =
        LALIGA_CATEGORIES.has($store.requestedServices.product.productFamily) &&
        !['skyprepagolight', 'izzitv_light', 'izzitv_lightm'].includes(
            $store.requestedServices.product.nombreCode
        );

    const handleVerifyPromotions = async () => {
        isVerifyingPromotions.set(true);

        getPromos(getExtras($store, $store_offer), (response) => {
            $store.requestedServices.promotions = response;
            isVerifyingPromotions.set(false);
            shouldVerifyPromotions.set(false);
        });
    };

    store.subscribe((value) => {
        let list = [];
        let subtotal = 0;
        let subtotalMovil = 0;
        let subtotalMovilPromos = 0;
        let izziAhorroTotal = 0;
        let totalConStreamingIzzi = 0;
        let totalCombos = 0;
        let promotionDiscount = 0;
        category = $store.requestedServices.product?.productFamily;

        hdItem = $store.requestedServices.product?.extrasMap.canalesCarta.find(
            (extra) =>
                extra.extra.extName == 'Hazlo HD Plus M' && extra.paqextDefault
        );

        if ($store.requestedServices.product != null) {
            total =
                $store.requestedServices.product.discountCost == null ||
                MULTI_CATEGORIES.has(category)
                    ? parseFloat($store.requestedServices.product.cost)
                    : parseFloat($store.requestedServices.product.discountCost);
            let opcionesModular =
                $store.requestedServices.product.opcionesModular;
            if (opcionesModular != undefined && opcionesModular != null) {
                opcionesModular.forEach((o) => {
                    izziAhorroTotal += Number(o.monto);
                });
            }
            totalConStreamingIzzi = total;
            if (
                $store.requestedServices.product.nombreCode.includes(
                    'izzitvhd'
                ) &&
                $store.requestedServices.product.nombreCode.includes('plus')
            ) {
                izziAhorroTotal += Number(
                    hdItem.extra.opcionesModular[0].monto
                );
            }
        }
        subtotal = 0;
        list = Object.entries($store.requestedServices.phoneExtras);
        list.forEach((item) => {
            subtotal += parseFloat(item[1].extra.cost);
        });
        total += subtotal;

        let hasStreamingTemp =
            $store.requestedServices.isVix ||
            $store.requestedServices.isNetflix ||
            $store.requestedServices.isHBO;

        subtotal = 0;
        list = Object.entries($store.requestedServices.channelExtras);
        list.forEach((item) => {
            if (
                ($store.requestedServices.product?.vel >= 60 ||
                    isVixIncluded) &&
                item[1].extra.extName === principalStreamersNames[0]
            ) {
                totalConStreamingIzzi -= parseFloat(item[1].extra.cost);
                if (
                    $store.requestedServices.promotions.length > 0 &&
                    $store.requestedServices.promotions.filter(
                        (promo) =>
                            promo.promoName.toUpperCase().includes('VIX') &&
                            !(
                                promo.promoType === 'Muestra producto' &&
                                promo.promoMode === 'Cargo Abono'
                            )
                    ).length > 0
                ) {
                    total += parseFloat(item[1].extra.cost);
                }
            } else {
                if (
                    item[1].extra.extName === 'Max basico con anuncios M' &&
                    $store.requestedServices.product?.vel >= 150
                ) {
                    subtotal += 0;
                } else {
                    subtotal += parseFloat(item[1].extra.cost);
                }
            }
            let opcionesModular = item[1].extra.opcionesModular;
            if (
                (opcionesModular != undefined &&
                    opcionesModular != null &&
                    item[1].combo) ||
                item[1].extra.extName == 'Hazlo HD Plus M'
            ) {
                opcionesModular.forEach((o) => {
                    if (
                        ([
                            CATEGORY_RESIDENCIAL,
                            CATEGORY_TRIPLEPLAY_MOVIL,
                        ].includes(category) &&
                            o.play == '2P') ||
                        ([CATEGORY_TRIPLEPLAY, CATEGORY_4PLAY].includes(
                            category
                        ) &&
                            o.play == '3P')
                    ) {
                        if (
                            $store.requestedServices.product.vel >= 60 &&
                            item[1].extra.extName === principalStreamersNames[0]
                        ) {
                        } else {
                            izziAhorroTotal += Number(o.monto);
                        }
                    }
                });
            }
            totalConStreamingIzzi +=
                (principalStreamersNames.includes(item[1].extra.extName) &&
                    item[1].combo) ||
                item[1].extra.extName == 'Hazlo HD Plus M'
                    ? parseFloat(item[1].extra.cost)
                    : 0;
            if (item[1].combo) totalCombos++;
        });
        total += subtotal;

        isComplete = true;
        if ($store.requestedServices.isCombo) {
            if (
                $store.requestedServices.product.productFamily ===
                    'residencial' &&
                $store.requestedServices.product.vel < 200
            ) {
                isComplete = totalCombos >= 1;
            } else {
                isComplete = totalCombos >= 2;
            }
        }

        subtotal = 0;
        list = Object.entries($store.requestedServices.tvExtensionsExtras);
        list.forEach((item) => {
            subtotal += parseFloat(item[1].extra.cost * item[1].nuevaCantidad);
            if (
                ['tripleplay', 'unlimited', 'izzinegocios_3P'].includes(
                    $store.requestedServices.product.productFamily
                )
            ) {
                subtotal -=
                    item[1].nuevaCantidad > 3
                        ? 36 * 3
                        : 36 * item[1].nuevaCantidad;
            }
            totalExtrasTV = subtotal;
        });
        total += subtotal;

        subtotal = 0;
        list = Object.entries($store.requestedServices.phoneExtensionsExtras);
        list.forEach((item) => {
            subtotal += parseFloat(item[1].extra.cost * item[1].nuevaCantidad);
        });
        total += subtotal - izziAhorroTotal;

        shouldVerifyPromotions.set(true);

        if ($store.requestedServices.promotions.length > 0) {
            promotionDiscount = $store.requestedServices.promotions.reduce(
                (acc, promo) => {
                    return (promo.promoType === 'Muestra producto' &&
                        promo.promoMode === 'Cargo Abono') ||
                        promo.promoMovil
                        ? acc
                        : acc + parseFloat(promo.promoPrice);
                },
                0
            );
            total += promotionDiscount;
        }

        izziAhorro = izziAhorroTotal;
        totalConStreaming = totalConStreamingIzzi;

        if (!omitir) {
            secondaryStreamers = $store.requestedServices.channelExtras.filter(
                (extra) => !isCombo(extra, $store, 'secondaryStreamers')
            );
        } else {
            secondaryStreamers = $store.requestedServices.channelExtras;
        }

        if (!hdItem) {
            hdItem = secondaryStreamers.find(
                (extra) => extra.extra.extName == 'Hazlo HD Plus M'
            );
            if (hdItem) {
                secondaryStreamers = secondaryStreamers.filter(
                    (extra) => extra.extra.extName != 'Hazlo HD Plus M'
                );
            }
        }

        hasStreaming = hasStreamingTemp;

        if ($store.purchaseStatus.installationExpress) {
            total += 100;
        }

        if ($store.requestedServices.izzimovil.length > 0) {
            total = $store.requestedServices.isSpMovil ? 0 : total;
            subtotalMovil = 0;

            $store.requestedServices.izzimovil.forEach((item) => {
                subtotalMovil += item.plan.extra
                    ? Number(
                          $store.requestedServices.isSpMovil &&
                              item.plan.extra.precioSP > 0
                              ? item.plan.extra.precioSP
                              : item.plan.extra.cost
                      )
                    : Number(item.plan.cost);

                if ($store.requestedServices.promotions.length > 0) {
                    subtotalMovilPromos = parseFloat(
                        $store.requestedServices.promotions
                            .filter((promo) => promo.promoMovil)
                            .reduce(
                                (acc, promo) =>
                                    acc + parseFloat(promo.promoPrice),
                                0
                            )
                    );
                }
            });

            totalMovil = subtotalMovil + subtotalMovilPromos;
            total += totalMovil;
        }

        // Costo de instalación
        subtotal = 0;
        if ($store.requestedServices.product?.precioInstalacion != null) {
            subtotal += Number(
                $store.requestedServices.product.precioInstalacion
            );
        }
        total += subtotal;
        totalPayment.set(total);
    });

    let MXNCurrency = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
    });

    function toggleDetails() {
        showDetails = !showDetails;
    }

    let clickHandler = () => {
        $store.requestedServices.total = total;
        $store.requestedServices.totalOriginal = total;
        $store.requestedServices.izzimovil.length > 0
            ? navigate('/compra/entrega', { replace: false })
            : navigate('/compra/datos', { replace: false });
    };

    function formatNumber(num) {
        var parts = (+num).toFixed(2).split('.');
        var finalNum =
            parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            (+parts[1] ? '.' + parts[1] : '');
        num = finalNum;
        return num;
    }

    $: {
        step = $store.settings.location.step;
    }
</script>

<section class="sidebar">
    <div class="sidebar-top text-center m-b-20">
        <p class="fw-semibold">Detalles de tu contratación</p>
    </div>
    <div class=" sidebar-top text-center m-b-20">
        <p class="fw-semibold text-fs-15">Precio total a pagar</p>
        <div
            class="h2 text-fs-36 fw-semibold {isSky
                ? 'blue-dark-text'
                : 'primary-text'} "
        >
            ${formatNumber(total)}
        </div>
        <p>Pago para contratar</p>
        <p
            class="text-fs-13 fw-semibold {isSky
                ? 'black-text'
                : 'aqua-text'} m-b-10"
        >
            Incluye primer mes
        </p>
    </div>
    <div
        class={step === 1 || step === 5 || showDetails || isMobile
            ? ''
            : 'hidden'}
    >
        <div class="pago-mensual">
            <p class="fw-semibold text-center m-b-25">
                Detalles de tu contratación
            </p>
            <div class="pure-g m-b-5">
                <div class="pure-u-1">
                    <p class="fw-semibold m-b-0">Paquete elegido</p>
                </div>
            </div>
            <div class="pure-g m-b-15">
                <div class="pure-u-15-24">
                    <p>{$store.requestedServices.product.title}</p>
                </div>
                <div class="pure-u-9-24 text-right">
                    {#if $store.requestedServices.product.discountCost == null || MULTI_CATEGORIES.has(category)}
                        <p>${formatNumber(totalConStreaming)}</p>
                    {:else}
                        <p>
                            ${formatNumber(
                                $store.requestedServices.product.discountCost
                            )}
                        </p>
                    {/if}
                </div>
            </div>
            {#if isSky}
                <div class="pure-g m-b-15">
                    <div class="pure-u-15-24">
                        <p>
                            {$store.requestedServices.product.itemInstalacion}
                        </p>
                    </div>
                    <div class="pure-u-9-24 text-right">
                        <p>
                            {MXNCurrency.format(
                                $store.requestedServices.product
                                    .precioInstalacion
                            )}
                        </p>
                    </div>
                </div>
            {/if}
            {#if $store.purchaseStatus.installationExpress}
                <div class="pure-g m-b-15">
                    <div class="pure-u-15-24">
                        <p>Instalación Express</p>
                    </div>
                    <div class="pure-u-9-24 text-right">
                        <p>$100</p>
                    </div>
                </div>
            {/if}
            {#if hasStreaming}
                <div class="pure-g m-b-5">
                    <div class="pure-u-1">
                        <p class="fw-semibold m-b-0">Streaming incluido</p>
                    </div>
                </div>
                {#if isVixIncluded}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>ViX Premium</p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p />
                        </div>
                    </div>
                {/if}
                {#if isAppleTvIncluded}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>Apple TV+</p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p />
                        </div>
                    </div>
                {/if}
                {#if isSkeeloIncluded}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>Skeelo</p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p />
                        </div>
                    </div>
                {/if}
                {#if isLaLigaIncluded}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>LALIGA EA sports</p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p />
                        </div>
                    </div>
                {/if}
                {#each Object.entries($store.requestedServices.channelExtras) as [key, value]}
                    {#if isCombo(value, $store, 'channelExtras') && !omitir && !isVixIncluded}
                        <div class="pure-g m-b-15">
                            <div class="pure-u-15-24">
                                <p>{value.extra.title}</p>
                            </div>
                            <div class="pure-u-9-24 text-right">
                                <p />
                            </div>
                        </div>
                    {/if}
                {/each}
            {/if}
            {#if (secondaryStreamers != undefined && secondaryStreamers != null && secondaryStreamers.length > 0) || hdItem}
                <div class="pure-g m-b-5">
                    <div class="pure-u-1">
                        <p class="fw-semibold m-b-0">Complementos de video</p>
                    </div>
                </div>

                {#if hdItem}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>{hdItem.extra.title}</p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p class="text-fs-13 fw-semibold aqua-text m-b-25">
                                Incluido
                            </p>
                        </div>
                    </div>
                {/if}

                {#each Object.entries(secondaryStreamers) as [key, value]}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>
                                {value.extra.title}<br />{getExtMessage(
                                    value.extra.extName,
                                    servicePaymentPeriodMessages
                                )}
                            </p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p>${formatNumber(value.extra.cost)}</p>
                        </div>
                    </div>
                {/each}
            {/if}
            {#each Object.entries($store.requestedServices.tvExtensionsExtras) as [key, value]}
                {#if $store.requestedServices.isSky}
                    <div class="cart-line-separator"></div>
                    <div class="pure-g m-b-5">
                        <div class="pure-u-1">
                            <p class="fw-semibold m-b-0">Adicionales</p>
                        </div>
                    </div>
                {/if}
                <div class="pure-g m-b-15">
                    <div class="pure-u-15-24">
                        <p>
                            ({value.nuevaCantidad}) {!$store.requestedServices
                                .isSky
                                ? 'Extensión'
                                : ''}
                            {value.extra.title}
                        </p>
                    </div>
                    <div class="pure-u-9-24 text-right">
                        <p>
                            ${formatNumber(parseFloat(totalExtrasTV))}
                        </p>
                    </div>
                </div>
            {/each}
            {#each Object.entries($store.requestedServices.phoneExtras) as [key, value]}
                <div class="pure-g m-b-15">
                    <div class="pure-u-15-24">
                        <p>{value.extra.title}</p>
                    </div>
                    <div class="pure-u-9-24 text-right">
                        <p>${formatNumber(value.extra.cost)}</p>
                    </div>
                </div>
            {/each}
        </div>
        {#if ($store.requestedServices.product.productFamily !== 'tv' && !isSky) || $store.requestedServices.promotions.length > 0}
            <div class="ahorro-row">
                <div class="m-b-15">
                    {#if isSky}
                        <p class="fw-bold">Descuentos aplicados</p>
                    {:else}
                        <p class="fw-bold text-center">
                            ¡ Visualiza tus descuentos !
                        </p>
                    {/if}
                </div>
                {#if $store.requestedServices.product.productFamily !== 'tv' && !isSky}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p class="primary-text fw-semibold">izzi ahorro</p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p class="primary-text fw-semibold">
                                ${formatNumber(izziAhorro)}
                            </p>
                        </div>
                    </div>
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p class="fw-semibold">
                                Precio del paquete con izzi ahorro
                            </p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p class="fw-semibold">
                                ${formatNumber(totalConStreaming - izziAhorro)}
                            </p>
                        </div>
                    </div>
                {/if}
                {#each Object.entries(promotions) as [key, value]}
                    {#if !value.promoName?.toUpperCase().includes('VIX')}
                        <div class="pure-g m-b-15">
                            <div class="pure-u-15-24">
                                <p
                                    class="fw-semibold {isSky
                                        ? 'blue-dark-text'
                                        : 'aqua-text'}"
                                >
                                    {value.promoName}
                                </p>
                            </div>
                            <div class="pure-u-9-24 text-right">
                                <p
                                    class="fw-semibold {isSky
                                        ? 'blue-dark-text'
                                        : 'aqua-text'}"
                                >
                                    {MXNCurrency.format(value.promoPrice)}
                                </p>
                            </div>
                        </div>
                    {:else if $store.requestedServices.product.vel === 40 && value.promoName
                            .toUpperCase()
                            .includes('VIX')}
                        <div class="pure-g m-b-15">
                            <div class="pure-u-15-24">
                                <p
                                    class="fw-semibold {isSky
                                        ? 'blue-dark-text'
                                        : 'aqua-text'}"
                                >
                                    {value.promoName}
                                </p>
                            </div>
                            <div class="pure-u-9-24 text-right">
                                <p
                                    class="fw-semibold {isSky
                                        ? 'blue-dark-text'
                                        : 'aqua-text'}"
                                >
                                    {MXNCurrency.format(value.promoPrice)}
                                </p>
                            </div>
                        </div>
                    {/if}
                {/each}
            </div>
        {/if}
        {#if $store.requestedServices.izzimovil.length > 0}
            <div class="ahorro-row">
                <p class="fw-semibold m-b-10 move-left">Planes izzi móvil</p>
                {#each Object.entries($store.requestedServices.izzimovil) as [key, value]}
                    {#if lineProps.filter((line) => line.title === value.title)[0]?.shouldShowInCart ?? true}
                        <div class="pure-g m-b-10">
                            <div class="pure-u-15-24">
                                <p>
                                    {value.title}
                                </p>
                            </div>
                            <div class="pure-u-9-24 text-right">
                                <p>
                                    {MXNCurrency.format(
                                        value.plan.extra
                                            ? $store.requestedServices
                                                  .isSpMovil &&
                                              value.plan.extra.precioSP > 0
                                                ? value.plan.extra.precioSP
                                                : value.plan.extra.cost
                                            : $store.requestedServices
                                                    .isSpMovil &&
                                                value.plan.precioSP > 0
                                              ? value.plan.precioSP
                                              : value.plan.cost
                                    )}
                                </p>
                            </div>
                        </div>
                    {/if}
                {/each}
            </div>
        {/if}
        {#if Object.entries($store.requestedServices.phoneExtensionsExtras).length > 0}
            <div class="pago-unico">
                <p class="text-fs-13 fw-semibold aqua-text m-b-25">
                    {$store.requestedServices.product.paqId > 38000
                        ? ''
                        : 'Pago único'}
                </p>
                {#each Object.entries($store.requestedServices.phoneExtensionsExtras) as [key, value]}
                    <div class="pure-g m-b-15">
                        <div class="pure-u-15-24">
                            <p>
                                ({value.nuevaCantidad}) Extensión {value.extra
                                    .title}
                            </p>
                        </div>
                        <div class="pure-u-9-24 text-right">
                            <p>
                                ${formatNumber(
                                    value.extra.cost * value.nuevaCantidad
                                )}
                            </p>
                        </div>
                    </div>
                {/each}
            </div>
        {/if}
        <div class="total-row">
            <div class="pure-g m-b-15">
                <div class="pure-u-15-24">
                    <p class="fw-semibold">Precio total a pagar</p>
                </div>
                <div class="pure-u-9-24 text-right">
                    <p
                        class="{isSky
                            ? 'black-text'
                            : 'primary-text'} fw-semibold"
                    >
                        ${formatNumber(total)}
                    </p>
                </div>
            </div>
        </div>
    </div>
    {#if step != 1 && step != 5 && !isMobile}
        <div class="section-details">
            <button
                type="button"
                class="button-details"
                class:blue-dark-text={isSky}
                on:click={toggleDetails}
            >
                {showDetails ? 'Ocultar detalles' : 'Ver más detalles'}
            </button>
        </div>
    {/if}
    {#if step == 1 && !isMobile}
        {#if !$shouldVerifyPromotions}
            <button
                type="button"
                on:click={clickHandler}
                class="pure__button {isSky
                    ? 'pure__button--blue-dark'
                    : 'pure__button--base'} pure__button--expand m-b-15"
                disabled={!isComplete}>Continuar</button
            >
        {:else}
            <button
                type="button"
                on:click={handleVerifyPromotions}
                class="pure__button {isSky
                    ? 'pure__button--blue-dark'
                    : 'pure__button--aqua'} pure__button--expand m-b-15"
                disabled={!isComplete}>Verificar promociones</button
            >
        {/if}
    {/if}
</section>
